import React, { useState, useEffect  } from 'react'
import {
  Row,
  Col,
  Button,
  Input,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import Alert from 'react-s-alert';
import * as MyAPI from '../../../utils/MyAPI'
import { LOCAL_STRAGE_KEY } from '../../../utils/Settings'
import { useDispatch } from "react-redux";
import * as UserActions from '../../../actions/UserActions'

// AccountPaymentHistory
const AccountPaymentHistory = (props) => {

  let [paymentHistory, setPaymentHistory] = useState([])
  let [pageNumber, setPageNumber] = useState(0)

  // componentDidMount
  useEffect(() => {

    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // get payment history
  let _firstScript = async () => {
    await _getPaymentHistory(props.login_token, 0)
  }

  // get payment history
  let _getPaymentHistory = async (login_token, page_number) => {

    props.setLoading(true)

    try {
      // logout on server
      let _results = await MyAPI.getPaymentHistory({
        login_token: login_token,
        page_number: page_number,
      })
      if (_results.status === "error") {
        throw Error(_results.message)
      }
      
      // list1
      if (_results.list1) {
        setPaymentHistory(_results.list1)
      }

    } catch (err) {
      console.log("err: ", err)
      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });
    }

    props.setLoading(false)
  }

  return (

    <div style={{
      padding: 4,
      backgroundColor: props.idx % 2 === 0 ? '#cccccc' : 'none',
    }}>

      <ListGroup style={{
        marginTop: 20,
        marginBottom: 20,
      }}>
        <ListGroupItem style={{
          backgroundColor: '#ffffff',
          color: '#555555',
        }}>
          <Row>
            <Col md="3" xs="12" style={{
              textAlign: 'left',
            }}>
              Date
            </Col>
            <Col md="8" xs="12" style={{
              textAlign: 'left',
            }}>
              ID
            </Col>
            <Col md="1" xs="12" style={{
              textAlign: 'left',
            }}>
              Amount
            </Col>
          </Row>
        </ListGroupItem>

        {paymentHistory.map((item, idx) => (
          <ListGroupItem key={item._id} style={{
            backgroundColor: '#ffffff',
            color: '#555555',
          }}>
            <Row>
              <Col md="3" xs="12">
                {item.createdAt}
              </Col>
              <Col md="8" xs="12">
                {item._id}
              </Col>
              <Col md="1" xs="12">
                {item.amount}
              </Col>
            </Row>
          </ListGroupItem>
        ))}

      </ListGroup>


    </div>
  )
}

export default AccountPaymentHistory
